export default __webpack_public_path__ + "static/media/banner_7.23824182.jpg";